<template>
  <div class="fundo">
    <div class="front">
      <h1 class="code-page" data-cursor-hover>404</h1>
      <p class="subtitle">Opsss... Essa página não existe.</p>

      <vs-button
        gradient
        class="center-btn"
        to="/"
        size="large"
        data-cursor-hover
      >
        Voltar para o início.
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" >
.fundo {
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: "";
    width: 60vh;
    height: 60vh;
    position: absolute;
    border: 1px solid var(--color-3);
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    @media screen and (max-width: 810px) {
      width: 80vw;
      height: 80vw;
      max-width: 400px;
      max-height: 400px;
    }
  }
}
.front {
  z-index: 2;
  text-align: center;
}
.code-page {
  font-size: 22vw;
  margin: 0;
  line-height: 1em;
  color: var(--color-3);
  background-image: url("https://picsum.photos/id/1042/1080/720");
  color: transparent;
  -moz-background-clip: text;
  -webkit-background-clip: text;
  @media screen and (max-width: 810px) {
    font-size: 45vw;
    margin-top: 15vw;
  }
}
.subtitle {
  font-weight: 500;
  margin: 16px 0 18px;
}
.center-btn {
  margin: 0 auto;
}
</style>